import SubstanceV4 from '@/views/product/components/product-card/composition/SubstanceV4.vue'
import SubstanceEditorStructured from './SubstanceEditorStructured.vue'

const SUBSTANCE_COMPONENTS = Object.freeze({
    SubstanceV4,
    SubstanceEditorStructured,
})

const DEFAULT_SUBSTANCE_COMPONENT = 'SubstanceV4'

function resolveSubstanceComponent(name = DEFAULT_SUBSTANCE_COMPONENT) {
    return SUBSTANCE_COMPONENTS[name] || SUBSTANCE_COMPONENTS[DEFAULT_SUBSTANCE_COMPONENT]
}

export {
    DEFAULT_SUBSTANCE_COMPONENT,
    SUBSTANCE_COMPONENTS,
    resolveSubstanceComponent,
}
